import http from '@/plugins/axios';

export default {
  getPartnersInfo() {
    return http.get('partner/get-partners-info');
  },
  activateIntegration(partnerId) {
    return http.post(`partner/${partnerId}/activate-partner`, {});
  },
  deactivateIntegration(partnerId) {
    return http.post(`partner/${partnerId}/deactivate-partner`, {});
  },
  googleSearchProduct(search) {
    const params = {
      search,
    };
    return http.get('google-shopping-excluded-products', {
      params,
    });
  },
  googleIncludedProducts() {
    return http.get('google-shopping-included-products');
  },
  googleIncludeProduct(productId) {
    return http.post('google-shopping-include-product', { productId });
  },
  googleExcludeProduct(productId) {
    return http.post('google-shopping-exclude-product', { productId });
  },
  googleSetIncludeAll(includeAll) {
    return http.post('google-shopping-set-include-all', { includeAll });
  },
  googleSetActive(active) {
    return http.post('google-shopping-set-active', { active });
  },
  googleSetSkuAsGtin(skuAsGtin) {
    return http.post('google-shopping-set-sku-as-gtin', { skuAsGtin });
  },
  updateAfterShipPreferences(payload) {
    const data = {
      apiKey: payload.apiKey,
      enabled: payload.enabled,
      postDeliveryDays: payload.postDeliveryDays,
    };
    return http.post('update-aftership-preferences', data);
  },
  updateGorgiasPreferences(payload) {
    const data = {
      user: payload.user,
      domain: payload.domain,
      key: payload.key,
      enabled: payload.enabled,
      ticketStars: payload.ticketStars,
      sendQuestionTicketGorgias: payload.sendQuestionTicketGorgias,
      importedReviewsTicketGorgias: payload.importedReviewsTicketGorgias,
    };
    return http.post('update-gorgias-preferences', data);
  },
  updateZendeskPreferences(payload) {
    const data = {
      domain: payload.domain,
      user: payload.user,
      password: payload.password === '' ? null : payload.password,
      apiKey: payload.apiKey === '' ? null : payload.apiKey,
      enabled: payload.enabled,
      ticketStars: payload.ticketStars,
      sendQuestionTicketZendesk: payload.sendQuestionTicketZendesk,
      importedReviewsTicketZendesk: payload.importedReviewsTicketZendesk,
    };
    return http.post('update-zendesk-preferences', data);
  },
  updateOmnisendPreferences(payload) {
    const data = {
      apiKey: payload.apiKey,
      enabled: payload.enabled,
    };
    return http.post('update-omnisend-preferences', data);
  },
  updateSalesforcePreferences(payload) {
    const data = {
      enabled: payload.enabled,
      baseUrl: payload.baseUrl,
      clientId: payload.clientId,
      clientSecret: payload.clientSecret,
      customNotificationId: payload.customNotificationId,
      password: payload.password,
      username: payload.username,
    };
    return http.post('update-salesforce-preferences', data);
  },
  updateLoyaltylionPreferences(payload) {
    const data = {
      secret: payload.secret,
      token: payload.token,
      enabled: payload.enabled,
    };
    return http.post('update-loyaltylion-preferences', data);
  },
  updateSmileIoPreferences(payload) {
    const data = {
      activityToken: payload.activityToken,
      clientToken: payload.clientToken,
      enabled: payload.enabled,
    };
    return http.post('update-smile-io-preferences', data);
  },
  updateRiseAiPreferences(payload) {
    const data = {
      enabled: payload.enabled,
      riseAiLeftReviewUrl: payload.riseAiLeftReviewUrl,
      riseAiLeftReviewPayload: payload.riseAiLeftReviewPayload,
    };
    return http.post('update-rise-ai-preferences', data);
  },
  googleSetExcludeImportedReviews(excludeImportedReviewsGoogleMerchantFeed) {
    return http.post('google-shopping-set-exclude-imported-reviews', {
      excludeImportedReviewsGoogleMerchantFeed,
    });
  },
  updateKlaviyoPreferences(payload) {
    const data = {
      publicToken: payload.publicToken,
      privateToken: payload.privateToken,
      listId: payload.listId,
      enabled: payload.enabled,
      feedEnabled: payload.feedEnabled,
      klaviyoStarsColor: payload.klaviyoStarsColor,
    };
    return http.post('update-klaviyo-preferences', data);
  },
  updateShopifyFlowPreferences(payload) {
    const data = {
      enabled: payload,
    };
    return http.post('update-shopify-flows-preferences', data);
  },
  syncKlaviyoProfiles() {
    return http.post('sync-klaviyo-profiles');
  },
  testKlaviyo(payload) {
    const data = {
      email: payload.email,
      option: payload.option,
    };
    return http.post('test-klaviyo', data);
  },
  updateLimespotPreferences(payload) {
    const data = {
      enabled: payload,
    };
    return http.post('update-limespot-preferences', data);
  },
  updateWiserPreferences(payload) {
    const data = {
      enabled: payload,
    };
    return http.post('update-wiser-preferences', data);
  },
  getGoogleShoppingAuthLink() {
    return http.post('/google-shopping-login').then(res => res.data);
  },
  revokeGoogleLogin() {
    return http.post('/google-revoke-login').then(res => res.data);
  },
  syncGoogleMerchants() {
    return http.post('/google-merchants-sync').then(res => res.data);
  },
  getGoogleShoppingIntegrationStatus() {
    return http.get('/google-shopping-integration-status').then(res => res.data);
  },
  getBazaarvoiceIntegrationStatus() {
    return http.get('/bazaarvoice-integration-status').then(res => res.data);
  },
  loadIntegrationProducts(
    integrationName,
    productId,
    { rowsPerPage, sortBy, descending, page, filterBy }
  ) {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy[0],
      order_direction: descending ? 'desc' : 'asc',
      filterBy: filterBy ? filterBy : null,
      productId,
    };
    return http
      .get(`/get-integration-products/${integrationName}`, {
        params,
      })
      .then(res => {
        return res.data;
      });
  },
  linkIntegrationProduct(integrationName, productId, integrationProductId) {
    const data = {
      productId,
      integrationProductId,
    };
    return http.post(`/integration-link-product/${integrationName}`, data);
  },
  unlinkIntegrationProduct(integrationName, integrationProductId) {
    const data = {
      integrationProductId,
    };
    return http.post(`/integration-unlink-product/${integrationName}`, data);
  },
  deleteIntegrationProduct(integrationName, integrationProductId) {
    const data = {
      integrationProductId,
    };
    return http.post(`/integration-delete-product/${integrationName}`, data);
  },
  runGoogleProductsSync() {
    return http.post('/google-products-full-sync').then(res => res.data);
  },
  runGoogleMerchantProductsSync(merchantId) {
    const data = {
      merchantId,
    };
    return http.post('/google-products-merchant-sync', data).then(res => res.data);
  },
  runBazaarvoiceProductsSync() {
    return http.post('/bazaarvoice-products-sync').then(res => res.data);
  },
  runBazaarvoiceReviewsSync() {
    return http.post('/bazaarvoice-reviews-sync').then(res => res.data);
  },
  updateBazaarvoiceSettings(payload) {
    const data = {
      bazaarvoicePasskey: payload.bazaarvoicePasskey,
    };
    return http.post('/bazaarvoice-settings', data);
  },
};
